import liff from "@line/liff";
import Axios from "@/config/customer-service";
import MicrositeAxios from "@/config/microsite-service";
import store from "@/store";

const urlRedirect = store.state.login.urlRedirect;

async function setProfile(profile) {
  return new Promise((resolve) => {
    store.commit("defaultSystem/SET_LINE_USER", profile);
    resolve();
  });
}
async function checkUserIsRegisteredLine(next, urlRedirect, accessToken) {
  try {
    const response = await Axios.get("checkUserIsRegisteredLine", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    const dataResponse = response?.data;
    if (dataResponse?.status == "registered") {
      localStorage.setItem("token", dataResponse.data.access_token);
      let url = { name: "main" }
      if (urlRedirect) {
        url = { path: urlRedirect }
      }
      store.commit("defaultSystem/SET_LOADING", false);
      return next({ ...url })
    }
    if (dataResponse?.status == "not_registered") {
      store.commit("defaultSystem/SET_LOADING", false);
      return next({ name: "checknumberLine" });
    }
    if (dataResponse?.status == "unauthorized") {
      store.commit("defaultSystem/SET_LOADING", false);
      return next({ name: "checknumberLine" });
    }
  } catch (err) {
    console.log("err :>> ", err);
    store.commit("defaultSystem/SET_LOADING", false);
    return next({ name: "login-bypass" });
  }
}
async function confirmLineId(data) {
  try {
    await Axios.post("confirmLineId", {
      ...data,
    });
  } catch (err) {
    console.log("err :>> ", err);
  }
}
async function confirmLineIdMicrosite(id, data) {
  try {
    await MicrositeAxios.post("confirmLineIdMicrosite/" + id, {
      ...data,
    });
  } catch (err) {
    console.log("err :>> ", err);
  }
}

export const loginLineUser = async (to, form, next) => {
  try {
    const vuex = localStorage.getItem("vuex");
    const defaultSystem = JSON.parse(vuex).defaultSystem;
    let liff_id = defaultSystem.site.liff_id;
    const inviteCode = to.query.invite === undefined ? "" : to.query.invite;
    if (!liff_id || liff_id == "-") {
      return next({ name: "login-bypass" });
    }

    // ========== ========== ========== ==========
    let checkHang = true;
    setTimeout(async () => {
      if (checkHang) {
        const LIFF_STORE_accessToken = localStorage.getItem(`LIFF_STORE:${liff_id}:accessToken`)
        const LIFF_STORE_decodedIDToken = localStorage.getItem(`LIFF_STORE:${liff_id}:decodedIDToken`)
        let profile_json = {};
        if (LIFF_STORE_decodedIDToken) {
          profile_json = JSON.parse(LIFF_STORE_decodedIDToken);
        }
        let accessToken_json = "";
        if (LIFF_STORE_accessToken) {
          accessToken_json = JSON.parse(LIFF_STORE_accessToken);
        }
        if (accessToken_json && Object.keys(profile_json).length > 0) {
          const accessToken = accessToken_json;
          store.commit("defaultSystem/SET_USER", { role: "Customer" });
          const profile = {
            "userId": profile_json.sub,
            "displayName": profile_json.name,
            "statusMessage": "",
            "pictureUrl": profile_json.picture,
          }
          store.commit("defaultSystem/SET_LOADING", true);
          await setProfile(profile);
          return checkUserIsRegisteredLine(next, urlRedirect, accessToken);
        }
      }
    }, 4000);

    // ========== ========== ========== ==========
    await liff.init({ liffId: liff_id, withLoginOnExternalBrowser: true, });
    checkHang = false;
    if (!liff.isInClient()) {
      if (!liff.isLoggedIn()) {
        // query invite
        if (inviteCode) {
          store.commit("friend/SET_INVITE", inviteCode);
        }
        liff.login({
          redirectUri: window.location.href,
        });
      }
    }

    // ========== ========== State ========== ==========
    const urlParams = new URLSearchParams(window.location.search);
    const liffState = urlParams.get('liff.state');
    const getParam = (key) => {
      if (liffState) {
        const innerParams = new URLSearchParams(liffState);
        if (innerParams.has(key)) {
          return innerParams.get(key);
        }
      }
      return urlParams.get(key);
    };

    // ========== ========== ========== ==========
    const profile = await liff.getProfile();
    if (profile) {
      const param_from = getParam('from');
      if (param_from == 'account') {
        if (profile) {
          store.commit("defaultSystem/SET_LOADING", true);
          await setProfile(profile);
          await confirmLineId({
            line_id: profile.userId,
            display_name: profile.displayName,
            profile_image: profile.pictureUrl,
          });
          store.commit("defaultSystem/SET_LOADING", false);
          return next({ name: "my-account" });
        }
      } else if (param_from == 'microsite-menu') {
        const param_slug = getParam('slug');
        const param_phone = getParam('phone');
        const param_microsite_id = getParam('microsite_id');
        if (param_slug && param_phone && param_microsite_id && profile) {
          store.commit("defaultSystem/SET_LOADING", true);
          await confirmLineIdMicrosite(param_microsite_id, {
            line_id: profile.userId,
            display_name: profile.displayName,
            profile_image: profile.pictureUrl,
            phone: param_phone,
            slug: param_slug,
          });
          store.commit("microsite/SET_USER", {
            user: {
              phone: param_phone,
              line_id: profile.userId,
            },
          });
          store.commit("defaultSystem/SET_LOADING", false);
          return next({
            name: param_from,
            params: {
              slug: param_slug
            },
            query: {
              phone: param_phone,
              line_id: profile.userId,
            }
          });
        }
      }
      // ========== ========== ========== ==========
      const accessToken = await liff.getAccessToken();
      store.commit("defaultSystem/SET_USER", { role: "Customer" });
      store.commit("defaultSystem/SET_LOADING", true);
      await setProfile(profile);
      return checkUserIsRegisteredLine(next, urlRedirect, accessToken);
    }
  } catch (error) {
    console.log("error :>> ", error);
    return next({ name: "login-bypass" });
  }
};
export const connectLineUser = async () => {
  let timer = null;
  try {
    const vuex = localStorage.getItem("vuex");
    const defaultSystem = JSON.parse(vuex).defaultSystem;
    const liff_id = defaultSystem.site.liff_id;
    if (!liff_id || liff_id == "-") {
      return false;
    }

    // ========== สร้าง Timeout Promise ==========
    const timeoutPromise = new Promise((_, reject) => {
      timer = setTimeout(() => {
        reject(new Error("LIFF_INIT_TIMEOUT"));
      }, 4000);
    });

    // ========== แข่งกันระหว่าง liff.init และ Timeout ==========
    await Promise.race([
      liff.init({ liffId: liff_id }),
      timeoutPromise
    ]);
    clearTimeout(timer);
    if (liff.isLoggedIn()) {
      return false;
    }

    const baseUrl = `${window.location.origin}/login-line`;
    const targetUrl = new URL(baseUrl);
    targetUrl.searchParams.set('from', 'account');
    liff.login({
      redirectUri: targetUrl.toString(),
    });
  } catch (error) {
    if (timer) clearTimeout(timer);
    if (error.message === "LIFF_INIT_TIMEOUT") {
      console.warn("LIFF init timed out after 4 seconds");
    } else {
      console.error("LIFF init error:", error);
    }
    return false;
  }
};
export const connectLineMicrositeUser = async (slug) => {
  let timer = null;
  try {
    const vuex = localStorage.getItem("vuex");
    const defaultSystem = JSON.parse(vuex).defaultSystem;
    const liff_id = defaultSystem?.site.liff_id;
    if (!liff_id || liff_id == "-") {
      return false;
    }
    const microsite = JSON.parse(vuex).microsite;
    const phone = microsite?.user.phone;
    if (!phone) {
      return false;
    }

    const microsite_id = microsite?.campaign?.id;
    if (!microsite_id) {
      return false;
    }

    // ========== สร้าง Timeout Promise ==========
    const timeoutPromise = new Promise((_, reject) => {
      timer = setTimeout(() => {
        reject(new Error("LIFF_INIT_TIMEOUT"));
      }, 4000);
    });

    // ========== แข่งกันระหว่าง liff.init และ Timeout ==========
    await Promise.race([
      liff.init({ liffId: liff_id }),
      timeoutPromise
    ]);
    clearTimeout(timer);
    if (liff.isLoggedIn()) {
      const profile = await liff.getProfile();
      if (profile) {
        store.commit("defaultSystem/SET_LOADING", true);
        await confirmLineIdMicrosite(microsite_id, {
          line_id: profile.userId,
          display_name: profile.displayName,
          profile_image: profile.pictureUrl,
          phone: phone,
        });
        store.commit("microsite/SET_USER", {
          user: {
            phone: phone,
            line_id: profile.userId,
          },
        });
        store.commit("defaultSystem/SET_LOADING", false);
        return location.reload();
      }
      return false;
    }

    const baseUrl = `${window.location.origin}/login-line`;
    const targetUrl = new URL(baseUrl);
    targetUrl.searchParams.set('from', 'microsite-menu');
    targetUrl.searchParams.set('slug', slug);
    targetUrl.searchParams.set('phone', phone);
    targetUrl.searchParams.set('microsite_id', microsite_id);
    liff.login({
      redirectUri: targetUrl.toString(),
    });
  } catch (error) {
    if (timer) clearTimeout(timer);
    if (error.message === "LIFF_INIT_TIMEOUT") {
      console.warn("LIFF init timed out after 4 seconds");
    } else {
      console.error("LIFF init error:", error);
    }
    return false;
  }
};